<div class="field-label-row">
    @if(isFieldEdited()) {
        <button
            type="button"
            class="field-undo-button"
            pTooltip="Deshacer ({{ originalModel[field.name] }})"
            tooltipPosition="top"
            (click)="undo()"
            [attr.aria-label]="'Deshacer cambio de ' + field.label">
            <i class="fa fa-undo" aria-hidden="true"></i>
        </button>
    }

    <label [attr.for]="field.name" class="field-label">
        <span>{{ field.label }}</span>

        @if(field.input.dropdownConfiguration?.summation) {
            <ng-container>{{ sum() }}</ng-container>
        }

        @if(field.conditions.isRequired) {
            <span class="required-asterisk"> *</span>
        }
    </label>

    @if(showFieldHelpButtons && getFieldHelpText()) {
        <button
            [tourAnchor]="tourAnchorId"
            type="button"
            class="field-help-button"
            [attr.aria-controls]="getHelpPanelId()"
            [attr.aria-expanded]="isHelpExpanded"
            [attr.aria-label]="'Mostrar ayuda sobre ' + field.label"
            (click)="toggleFieldHelp($event)">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
        </button>
    }

    @if(field.buttons) {
        @for (button of field.buttons; track $index) {
            <div class="col col-md-1 ms-1">
                <button
                    [class]="button.class"
                    [style]="button.style"
                    (click)="button?.function?.()"
                    pTooltip="{{ button.tooltip }}"
                    tooltipPosition="{{ button.tooltipPosition }}"
                    type="button">
                    <i [class]="button.icon" aria-hidden="true"></i>
                    <span *ngIf="button.label">{{ button.label }}</span>
                </button>
            </div>
        }
    }
</div>

@if(showFieldHelpButtons && isHelpExpanded) {
    @let help = getFieldHelpDetails();
    <aside [id]="getHelpPanelId()" class="field-help-panel" role="note">
        <strong>{{ help.title }}</strong>
        <p>{{ help.summary }}</p>

        @if(help.officialTerm) {
            <p><span>Término oficial:</span> {{ help.officialTerm }}</p>
        }

        @if(help.why) {
            <p><span>Para qué sirve:</span> {{ help.why }}</p>
        }

        @if(help.whereToFind) {
            <p><span>Dónde encontrarlo:</span> {{ help.whereToFind }}</p>
        }

        @if(help.example) {
            <p><span>Ejemplo:</span> {{ help.example }}</p>
        }

        @if(help.nextStep) {
            <p><span>Qué hacer ahora:</span> {{ help.nextStep }}</p>
        }

        @if(help.normativeNote) {
            <p class="field-help-normative-note">{{ help.normativeNote }}</p>
        }
    </aside>
}
